import React from 'react'
import { uploadTemplateFile } from "./inputOuputFunctions";
import {getFormRow, getFormRowVal} from '../../cmn/docAutomation/formFunctions';
import { getFileDownloadLink } from "../../../helper/uiFunctions";
import SarasTrans from '../../../library/notifications/SarasTrans';

const ImportData = (props) => {
    const { viewData, onFileUpload } = props;

    const onFileSelect = (e)=>{
        uploadTemplateFile(docType.val, e.currentTarget.files, onFileUpload )
    }

    if (!viewData)
        return (null);

    const templateDtlRow = getFormRow(viewData.viewRows, "0");
    const docType = getFormRowVal(templateDtlRow,"importDocType");
    const fileName = getFormRowVal(templateDtlRow,"importTemplateFile");

    return (
        <div style={{ marginTop: "15px", marginLeft: "15px" }}>
            <a className="uiLink" href={getFileDownloadLink(fileName.val, "it")} rel="noopener noreferrer" target="_blank"><SarasTrans value = "Download Import Template File"/></a>

            <div className="uiSpacer10">
                <span className="uiLbl"><SarasTrans value = "Select File"/></span>
                <input type='file' cassName="uiSpacerH5 uiFormInput" onChange={onFileSelect} />
            </div>
        </div>
    )
}

export default ImportData